import React from 'react';

const ContactMe = () => (
  <div className="ContactMe" id="contact">
    <div className="sectionHeading">
      <div className="sectionLeftHeading">
        <h3 className="headingPinked">Contact me</h3>
        <h2>Interested? Let&apos;s Connect</h2>
      </div>
      <div className="sectionRightMoreDetails" />
    </div>

    <div className="contactMeBody">
      <div className="footerLeft">
        <div className="footl">
          <p><i className="fa fa-map-marker" aria-hidden="true" /></p>
          <p>Nairobi, Kenya.</p>
        </div>
        <div className="footl">
          <p><i className="fa fa-phone" aria-hidden="true" /></p>
          <p>+254727475518 \</p>
          <p>+254792693975</p>
        </div>
        <div className="footl">
          <p><i className="fa fa-envelope-o" aria-hidden="true" /></p>
          <p><a href="mailto:nemwelnyandoro20@gmail.com">mail me</a></p>
        </div>
      </div>
      <div className="footerRight">
        <form className="form" action="https://formspree.io/f/mgedowaj" method="POST">
          <input type="text" name="name" maxLength="70" placeholder="&#xf007; Your names *" required />
          <input type="tel" name="telephone" placeholder="&#xf095; Your mobile number" />
          <input type="email" name="_replyto" placeholder="&#xf0e0; example@gmail.com *" required />
          <textarea name="message" placeholder="&#xf040; Write your message *" minLength="1" maxLength="1500" />
          <button type="submit">
            Contact me
            <i className="fa fa-paper-plane" aria-hidden="true" />
          </button>
        </form>
      </div>
    </div>
  </div>
);

export default ContactMe;
